import { combineReducers } from 'redux';
import dashboard from './main/dashboard';
import colors from './main/colors';
import config from './main/config';
import leftSidebar from './main/left-sidebar';
import palettes from './main/palettes';

import products from './products/reducer';
import orders from './orders/reducer';
import customers from './customers/reducer';
import user from './user/reducer';
import pricing from './pricing/slice';
import locations from './locations';

const rootReducer = combineReducers({
  dashboard,
  colors,
  config,
  leftSidebar,
  palettes,
  products,
  orders,
  customers,
  user,
  pricing,
  locations,
});

export default rootReducer;
